// extracted by mini-css-extract-plugin
export default {"modal":"duplicate_modal__iA3Kl"};